import dayjs from 'dayjs'
import 'dayjs/locale/ro'
import relativeTime from 'dayjs/plugin/relativeTime'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(relativeTime)
dayjs.extend(localizedFormat)
dayjs.locale('ro')

export default dayjs
